import { render, staticRenderFns } from "./workOrderListDetail.vue?vue&type=template&id=38be3f64&scoped=true&"
import script from "./workOrderListDetail.vue?vue&type=script&lang=js&"
export * from "./workOrderListDetail.vue?vue&type=script&lang=js&"
import style0 from "./workOrderListDetail.vue?vue&type=style&index=0&id=38be3f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be3f64",
  null
  
)

export default component.exports